import(flu.chunks.swiper).then((_ref) => {
  let { Swiper, Navigation } = _ref;
  Swiper.use([Navigation]);
  const swipperFeatured = new Swiper(".inst-tktk__swiper", {
    slidesPerView: "auto",
    spaceBetween: 0,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      500: {
        slidesPerView: 3,
      },
    },
    navigation: {
      nextEl: ".inst-tktk__button-next",
      prevEl: ".inst-tktk__button-prev",
    },
  });
});
